export const AUTH_APP_LANGUAGES = [
  'en',
  'de',
  'es',
  'fa',
  'fr',
  'hi',
  'id',
  'it',
  'ja',
  'ko',
  'nl',
  'th',
  'vi',
  'zh',
  'zh-TW'
]
